import React, {PropTypes} from "react";

class ModalExitView extends React.Component {

  constructor() {
    super();
  }

  render() {
    return (<div className="col-xs-12">

        <div className="col-xs-12">

          <table className="table table-bordered" cellpadding="0" cellspacing="0" border="0">
            <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
            </thead>
            <tbody>

            <tr>
              <td>Date of Resignation:</td>
              <td>{new Date(this.props.employee.doResignation).toDateString()}</td>
            </tr>
            <tr>
              <td>Last Working Day:</td>
              <td>{this.props.employee.doLeaving != null ? new Date(this.props.employee.doLeaving).toDateString() : 'NA'}</td>
            </tr>
            <tr>
              <td>Notice Period Status</td>
              <td>{this.props.employee.noticePeriodStatus}</td>
            </tr>
            <tr>
              <td>Manager Status</td>
              <td>{this.props.employee.managerStatus}</td>
            </tr>
            <tr>
              <td>IT Status</td>
              <td>{this.props.employee.itStatus}</td>
            </tr>
            <tr>
              <td>Facilities Status</td>
              <td>{this.props.employee.adminStatus}</td>
            </tr>
            <tr>
              <td>Finance Status</td>
              <td>{this.props.employee.financeStatus}</td>
            </tr>
            </tbody>
          </table>
        </div>


      </div>
    );
  }
}

ModalExitView.propTypes = {};

export default ModalExitView;





/** WEBPACK FOOTER **
 ** ./src/feature/myProfile/MyExit/ModalExitView.js
 **/